import styled from "styled-components";
import { mixins } from "@similarweb/styles";
import type { FontVariant } from "@similarweb/styles";

export const CellWithFontVariant = styled.div<{ variant: FontVariant }>`
    div {
        ${({ variant }) => mixins.setFontVariant(variant)};
    }
`;
